if (!customElements.get('shipping-estimator')) {
  customElements.define('shipping-estimator', class extends HTMLElement {
    connectedCallback() {
      this.formState = this.querySelector('[data-form-state]');
      this.resultsState = this.querySelector('[data-results-state]');
      this.form = this.querySelector('[data-shipping-form]');
      this.input = this.querySelector('[data-zip-input]');
      this.submitBtn = this.querySelector('[data-submit-btn]');
      this.changeCpBtn = this.querySelector('[data-change-cp]');
      this.resultsCp = this.querySelector('[data-results-cp]');
      this.loadingEl = this.querySelector('[data-loading]');
      this.errorEl = this.querySelector('[data-error]');
      this.deliverySection = this.querySelector('[data-delivery-section]');
      this.pickupSection = this.querySelector('[data-pickup-section]');

      try {
        this.zipCodes = JSON.parse(this.querySelector('[data-zip-codes]').textContent);
      } catch (e) {
        this.zipCodes = {};
      }
      this.deliveryRates = this.querySelector('[data-delivery-rates]');
      this.pickupRates = this.querySelector('[data-pickup-rates]');

      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.changeCpBtn.addEventListener('click', this.onChangeCp.bind(this));
      if (this.dataset.context !== 'cart') {
        document.addEventListener('variant:changed', this.onVariantChanged.bind(this));
      } else {
        document.addEventListener('cart:updated', this.onCartUpdated.bind(this));
      }

      var saved = localStorage.getItem('shipping_estimator_zip');
      if (saved) this.input.value = saved;
    }

    onSubmit(e) {
      e.preventDefault();
      var zip = this.input.value.trim();
      if (!zip) return;
      localStorage.setItem('shipping_estimator_zip', zip);
      this.fetchRates(zip);
    }

    onChangeCp() {
      this.resultsState.hidden = true;
      this.errorEl.hidden = true;
      this.formState.hidden = false;
      this.input.focus();
      this.input.select();
    }

    onVariantChanged() {
      var variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        this.dataset.variantId = variantInput.value;
        if (!this.resultsState.hidden) {
          this.resultsState.hidden = true;
          this.formState.hidden = false;
        }
      }
    }

    onCartUpdated(event) {
      if (this._isFetching) return;
      this.showWrapper(event);
      if (!this.resultsState.hidden) {
        this.resultsState.hidden = true;
        this.errorEl.hidden = true;
        this.formState.hidden = false;
      }
    }

    showWrapper(event) {
      var wrapper = this.closest('.cart-drawer__shipping-estimator');
      if (!wrapper) return;
      if (event && event.detail && event.detail.cart) {
        wrapper.classList.toggle('hidden', event.detail.cart.item_count === 0);
      }
    }

    isCartMode() {
      return this.dataset.context === 'cart';
    }

    async fetchRates(zip) {
      if (!this.isCartMode()) {
        var variantId = parseInt(this.dataset.variantId);
        if (!variantId) return;
      }

      this._isFetching = true;
      this.hideAll();
      this.loadingEl.hidden = false;
      this.submitBtn.disabled = true;

      var addToCartBtns = this.isCartMode() ? [] : document.querySelectorAll('[name="add"], .product-form__submit');
      addToCartBtns.forEach(function(btn) { btn.disabled = true; });

      var cartBackup = null;

      try {
        if (!this.isCartMode()) {
          cartBackup = await this.request('GET', '/cart.js');
          await this.request('POST', '/cart/clear.js');
          await this.request('POST', '/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
        }

        var zipData = this.getZipData(zip);

        this.addressParams = new URLSearchParams({
          'shipping_address[country]': 'Argentina',
          'shipping_address[province]': zipData.province,
          'shipping_address[city]': zipData.city,
          'shipping_address[zip]': zip,
          'shipping_address[address1]': 'test 123'
        });

        var prepareParams = new URLSearchParams(this.addressParams);
        prepareParams.set('include_carrier_rates', 'true');

        var rates = [];
        for (var attempt = 0; attempt < 3; attempt++) {
          await fetch('/cart/prepare_shipping_rates.json?' + prepareParams.toString(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          });
          await this.delay(1500);

          rates = await this.pollRates();
          if (rates.length > 0) break;
        }

        if (!this.isCartMode()) {
          await this.request('POST', '/cart/clear.js');
          await this.restoreCart(cartBackup);
        }

        this.renderResults(rates, zip);
      } catch (err) {
        console.error('Shipping estimator error:', err);

        if (!this.isCartMode()) {
          try {
            await this.request('POST', '/cart/clear.js');
            if (cartBackup) await this.restoreCart(cartBackup);
          } catch (restoreErr) {
            console.error('Cart restore error:', restoreErr);
          }
        }

        this.hideAll();
        this.formState.hidden = false;
        this.errorEl.hidden = false;
        this.errorEl.textContent = 'No pudimos calcular los costos de envío. Intentá de nuevo.';
      } finally {
        this._isFetching = false;
        this.submitBtn.disabled = false;
        addToCartBtns.forEach(function(btn) { btn.disabled = false; });
      }
    }

    getZipData(zip) {
      var entry = this.zipCodes[String(zip)];
      return entry || { province: 'Buenos Aires', city: '' };
    }

    async request(method, url, body) {
      var opts = { method: method, headers: { 'Content-Type': 'application/json' } };
      if (body) opts.body = JSON.stringify(body);
      var res = await fetch(url, opts);
      if (!res.ok) throw new Error(url + ' failed: ' + res.status);
      return res.json();
    }

    async pollRates() {
      for (var i = 0; i < 10; i++) {
        try {
          var res = await fetch('/cart/async_shipping_rates.json?' + this.addressParams.toString());
          var text = await res.text();
          if (text && text !== 'null') {
            var data = JSON.parse(text);
            if (data && data.shipping_rates && data.shipping_rates.length > 0) {
              return data.shipping_rates;
            }
          }
        } catch (e) {}
        await this.delay(1000);
      }
      return [];
    }

    async restoreCart(backup) {
      if (!backup || !backup.items || !backup.items.length) return;
      var items = backup.items.map(function(item) {
        return { id: item.variant_id, quantity: item.quantity, properties: item.properties };
      });
      await this.request('POST', '/cart/add.js', { items: items });
    }

    delay(ms) {
      return new Promise(function(resolve) { setTimeout(resolve, ms); });
    }

    renderResults(rates, zip) {
      this.hideAll();
      this.resultsCp.textContent = zip;

      var pickupKeywords = ['retir', 'pick', 'sucursal', 'punto'];
      var delivery = [];
      var pickup = [];

      rates.forEach(function(rate) {
        var nameLower = rate.name.toLowerCase();
        var isPickup = pickupKeywords.some(function(kw) { return nameLower.indexOf(kw) !== -1; });
        if (isPickup) {
          pickup.push(rate);
        } else {
          delivery.push(rate);
        }
      });

      if (delivery.length > 0) {
        this.deliverySection.hidden = false;
        this.deliveryRates.innerHTML = delivery.map(this.renderRateCard.bind(this)).join('');
      } else {
        this.deliverySection.hidden = true;
      }

      if (pickup.length > 0) {
        this.pickupSection.hidden = false;
        this.pickupRates.innerHTML = pickup.map(this.renderRateCard.bind(this)).join('');
      } else {
        this.pickupSection.hidden = true;
      }

      if (rates.length === 0) {
        this.formState.hidden = false;
        this.errorEl.hidden = false;
        this.errorEl.textContent = 'No encontramos medios de envío para este código postal.';
        return;
      }

      this.formState.hidden = true;
      this.resultsState.hidden = false;
    }

    renderRateCard(rate) {
      var price = parseFloat(rate.price);
      var isFree = price === 0;
      var deliveryHtml = '';

      if (rate.delivery_range) {
        var min = rate.delivery_range.min;
        var max = rate.delivery_range.max;
        if (min && max) {
          deliveryHtml = '<span class="shipping-estimator__rate-delivery">' +
            this.formatDeliveryRange(min, max) + '</span>';
        }
      }

      var priceHtml = '';
      if (isFree) {
        priceHtml = '<span class="shipping-estimator__rate-price shipping-estimator__rate-price--free">GRATIS</span>';
        if (rate.original_price && parseFloat(rate.original_price) > 0) {
          priceHtml += '<span class="shipping-estimator__rate-price--original">' +
            this.formatPrice(rate.original_price) + '</span>';
        }
      } else {
        priceHtml = '<span class="shipping-estimator__rate-price">' + this.formatPrice(rate.price) + '</span>';
      }

      var desc = rate.description || rate.name;
      var descHtml = '<span class="shipping-estimator__rate-description">' + this.escapeHtml(desc) + '</span>';

      return '<div class="shipping-estimator__rate">' +
        '<div class="shipping-estimator__rate-info">' +
          '<span class="shipping-estimator__rate-name">' + this.escapeHtml(rate.name) + '</span>' +
          descHtml +
          deliveryHtml +
        '</div>' +
        '<div class="shipping-estimator__rate-pricing">' + priceHtml + '</div>' +
      '</div>';
    }

    formatPrice(priceStr) {
      var amount = parseFloat(priceStr);
      if (isNaN(amount)) return priceStr;
      return '$' + amount.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    formatDeliveryRange(minDays, maxDays) {
      var days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
      var now = new Date();
      var minDate = new Date(now);
      minDate.setDate(now.getDate() + minDays);
      var maxDate = new Date(now);
      maxDate.setDate(now.getDate() + maxDays);

      var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
      var minDay = days[minDate.getDay()];
      var maxDay = days[maxDate.getDay()];
      var minStr = pad(minDate.getDate()) + '/' + pad(minDate.getMonth() + 1);
      var maxStr = pad(maxDate.getDate()) + '/' + pad(maxDate.getMonth() + 1);

      return 'Llega entre el ' + minDay + ' ' + minStr + ' y el ' + maxDay + ' ' + maxStr;
    }

    escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    hideAll() {
      this.loadingEl.hidden = true;
      this.errorEl.hidden = true;
      this.deliverySection.hidden = true;
      this.pickupSection.hidden = true;
    }
  });
}
